export function removeClassFromElements(className, elementObjects) {
  if (elementObjects.constructor === Array) elementObjects.forEach(element => element.classList.remove(className));
  else elementObjects.classList.remove(className)
}

export function addClassToElements(className, elementObjects) {
  if (elementObjects.constructor === Array) elementObjects.forEach(element => element.classList.add(className));
  else elementObjects.classList.add(className)
}
